import React from 'react';
import { Mail } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = ({ onChatClick }) => {
  return (
    <nav data-testid="navbar" className="fixed top-0 w-full z-50 bg-white/70 backdrop-blur-xl border-b border-slate-200/50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <a href="/" data-testid="navbar-logo" className="flex items-center">
            <img src="https://customer-assets.emergentagent.com/job_38ea2e2e-0b2a-4c96-90e7-893185248e11/artifacts/fcaqs56k_logo.png" alt="Guardifix" className="h-8" />
          </a>

          <Button
            data-testid="navbar-contact-btn"
            onClick={onChatClick}
            className="bg-blue-700 hover:bg-blue-800 text-white font-semibold px-5 py-2 rounded-lg transition-all duration-200 hover:scale-[1.02] flex items-center gap-2"
          >
            <Mail className="h-4 w-4" />
            <span className="hidden sm:inline">Contact Us</span>
            <span className="sm:hidden">Contact</span>
          </Button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
